import { render, staticRenderFns } from "./NoLineTips.vue?vue&type=template&id=dedea826"
import script from "./NoLineTips.vue?vue&type=script&lang=js"
export * from "./NoLineTips.vue?vue&type=script&lang=js"
import style0 from "./NoLineTips.vue?vue&type=style&index=0&id=dedea826&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports